import { fromJS } from 'immutable';
import { convertArrayElemToLowerCase } from "../CSR/utils/CommonUtils";
import * as actionTypes from "../actions/globalActionTypes"

const initialState = fromJS({
  activeFlow: '',
  pageActive: '',
  accountID: '',
  activePageStepNumber: 1,
  globalError:{
    error:false,
    message:null,
    primaryCtaLabel:"LOGOUT",
    isLogout:true,
    redirect:null,
    isDirectlogout:false,
    isRedirectfirst:false
  },
  stepperConfig: [],
  showSessionPopUp: false,
  countDown: 60,
  accountSummary: {
    isLoading: false,
    data: [],
    error: '',
  },
  stepperUpdateIndex: {
    status: false,
    index: 1,
  },
  accountdetails_data: {
    isLoading: true,
    data: [],
    error: ""
  },
  resetData: {
    isLoading: true,
    data: {},
    error: ""
  },
  stepperEditIndex: {
    status: false,
    index: 1,
  },
  account: {
    status: false,
  },
  advisors: [],
  selectedHeader: "",
  availableBalance: '',
  csr: {
    business_functions: [],
    applicable_business_function: []
  },
  isGlobalAccountSummaryLoading: false,
  accountChangedOnfinacialAdvisor: null,
  codeValueMappingData: {}
});



const setError = (state, action) => {
  return state.setIn(['globalError', 'error'], true).setIn(['globalError', 'errtitle'], action?.title || 'Something went wrong at our end').setIn(['globalError', 'message'], action?.error?.response?.message||action?.message).setIn(['globalError','primaryCtaLabel'],action.primaryCtaLabel).setIn(['globalError','isLogout'],action.isLogout).setIn(['globalError','redirect'],action.redirect).setIn(['globalError','isDirectlogout'],action.isDirectlogout).setIn(['globalError','isRedirectfirst'],action.isRedirectfirst);
}

const globalStateReducer = (state = initialState, action) => {
  if (action.error) {
    if (action.error.response.status === 401) {
      return setError(state, action);
    }
  }
  switch (action.type) {
    case actionTypes.resetStepperStateType:
      let resetState = { status: false, index: 1 };
      return state.setIn(["stepperEditIndex"], resetState).setIn(["stepperUpdateIndex"], resetState);
    case actionTypes.motherOfAllErrorsType:
      return setError(state, action);
    case actionTypes.editStepperIndexType:
      return state.setIn(["stepperEditIndex"], action.payload);
    case actionTypes.updateStepperIndexType:

      return state.setIn(["stepperUpdateIndex"], action.payload);
    case actionTypes.handleServerError:
      return setError(state,action.payload)
    case actionTypes.headerDataType:

      return state.setIn(["selectedHeader"], action.payload);
    case actionTypes.updateActiveFlowType:

      return state.set('activeFlow', action.payload);
    case actionTypes.updateActivePageType:

      return state.set('pageActive', action.payload);
    case actionTypes.updateActivePageStepNumberType:

      return state.set('activePageStepNumber', action.payload);
    case actionTypes.updatePageSteptoFinishType:

      return state.updateIn([
        'stepperConfig',
      ], (item) => {
        const activePageStepNumber = state.get('activePageStepNumber');
        return item.map((step, index) => {
          if (index !== activePageStepNumber - 1) {
            return step;
          }
          return {
            ...step,
            status: 'finish',
          };
        });
      });
    case actionTypes.updatePageStepToProcessType:

      return state.updateIn([
        'stepperConfig',
      ], (item) => {
        const activePageStepNumber = state.get('activePageStepNumber');
        return item.map((step, index) => {
          if (index !== activePageStepNumber - 1) {
            return step;
          }
          return {
            ...step,
            status: 'process',
          };
        });
      });
    case actionTypes.updateStepperAllToFinishType:

      return state.set('stepperConfig', action.payload);

    case actionTypes.updateStepperConfigType:

      return state.set('stepperConfig', action.payload.stepperConfig);
    case actionTypes.fetchSummaryType:

      return state.setIn(['accountSummary', 'isLoading'], !action.payload);
    case actionTypes.summaryDataSuccessType:

      return state.setIn(['accountSummary', 'data'], action.payload)
        .setIn(['accountSummary', 'isLoading'], !state.accountSummary.isLoading);
    case actionTypes.summaryDataErrorType:

      return state.setIn(['accountSummary', 'error'], action.payload)
        .setIn(['accountSummary', 'isLoading'], !state.accountSummary.isLoading);


    case actionTypes.accountChangeType:

      return state.setIn(['accountID'], action.payload.accountID)
        .setIn(['availableBalance'], null)
        .setIn(['currentBalance'], null);
    case actionTypes.accountChangeAfterOAAType:

      return state.setIn(['accountID'], action.payload.accountID)
        .setIn(['account', 'status'], true);
    case actionTypes.changeAccountStatusType:

      return state.setIn(['account', 'status'], false);
    case actionTypes.showPopupType:
      return state.setIn(['countDown'], 59)
        .setIn(['showSessionPopUp'], true);
    case actionTypes.hidePopupType:

      return state.setIn(['countDown'], 60)
        .setIn(['showSessionPopUp'], false);
    case actionTypes.decrementTimerType:

      return state.setIn(['countDown'], state.getIn(['countDown']) - 1);
    case actionTypes.exitExchangeType: {
      return state.setIn(['activePageStepNumber'], 1)
        .setIn(['stepperConfig'], []);
    }
    case actionTypes.makeUserSessionSuccessType: 
      return state.setIn(["accountdetails_data", "isLoading"], false);
    case actionTypes.CSRDataSuccessType:
     return state.setIn(['navBarData'], action.payload);
    case actionTypes.csrBusinessFunctionSuccessType:
      return state.setIn(["csr", "business_functions"], convertArrayElemToLowerCase(action.payload));
    case actionTypes.setCSRBusinessFunctionItemsType:

      return state.setIn(["csr", "applicable_business_function"], action.payload)

    case actionTypes.accountDetailsDataSuccessType:

      return state
        .setIn(["accountdetails_data", "data"], action.payload)
        .setIn(["accountdetails_data", "isLoading"], false);

    case actionTypes.accountDetailsDataSuccessLoaderType:
      return state.setIn(["accountdetails_data", "isLoading"], true);
    case actionTypes.clearGlobalErrorType:
      {
        return state.setIn(['globalError', 'error'], false)
          .setIn(['globalError', 'message'], null).setIn(['globalError','primaryCtaLabel'],"LOGOUT").setIn(['globalError','isLogout'],true).setIn(['globalError','redirect'],null).setIn(['globalError','isDirectlogout'],false).setIn(['globalError','isRedirectfirst'],false)
      }
    case actionTypes.hideErrorModalType:
      return state.setIn(['globalError', 'error'], false);
    case actionTypes.fetchAccountAdvisorsSuccessType:

      {
        return state.setIn(['advisors'], action.payload.advisors);
      }
    case actionTypes.getAvailableBalanceWorkerSuccessType:

      return state.setIn(
        ["availableBalance"], action.payload.availableBalance
      ).setIn(
        ["currentBalance"], action.payload.currentBalance
      );
    case actionTypes.primaryAccountChangedType:

      return state.setIn(['accountID'], action.payload);
    case actionTypes.modifyStepperConfigType:

      return state.set('stepperConfig', action.payload);
    case actionTypes.getCodeValueMappingSucessType:
      return state.setIn(['codeValueMappingData'], action.payload);

    case actionTypes.getCodeValueMappingFailedType:
      return state.setIn(['codeValueMappingData'], {});

    case actionTypes.fetchUserSuccessType:
      return state.setIn(['userInfo', 'data'], action.payload)
              .setIn(['userInfo', 'error'], false);

    case actionTypes.fetchUserInfoFailureType:      
      return state.setIn(['userInfo', 'error'], action.userInfoError);

    default:
      return state;

  }
};

export default globalStateReducer;